// Reads the cached settings (written by use-settings) to decide whether the
// merged comment feed should hide TMDB reviews and show only user comments.
// Defaults to showing them for logged-out users or before settings load.
export const hideTmdbReviews = (): boolean => {
  try {
    const cached = localStorage.getItem('settings-cache')
    if (!cached) return false
    const settings = JSON.parse(cached)
    return settings?.hideTmdbReviews ?? false
  } catch {
    return false
  }
}
